<template>
  <div class="feedbackDetail">
    <div class="detail-head">
      <div @click="goUser">
        <el-avatar
          :src="DetailData.HeadPic || circleUrl"
          :size="100"
        ></el-avatar>
      </div>
      <div>
        <el-descriptions
          :colon="false"
          :column="2"
          :labelStyle="{
            display: 'inline',
            textAlign: 'right',
            color: '#86909C',
            width: '148px',
          }"
          :contentStyle="{
            color: '#1D2129',
          }"
        >
          <el-descriptions-item label="反馈单号：">{{
            DetailData.id
          }}</el-descriptions-item>
          <el-descriptions-item> </el-descriptions-item>
          <el-descriptions-item label="用户：">
            <span class="showUser" @click="goUser"
              >{{ DetailData.RealName || "-" }}
            </span>
          </el-descriptions-item>
          <el-descriptions-item label="用户类型：">{{
            DetailData.Uuid ? "临时用户" : "注册用户"
          }}</el-descriptions-item>
          <el-descriptions-item label="反馈时间：">{{
            DetailData.CreateTime || "-"
          }}</el-descriptions-item>
          <el-descriptions-item label="最新回复时间：">{{
            DetailData.LastModifyTime || "-"
          }}</el-descriptions-item>
        </el-descriptions>
      </div>
      <div style="line-height: 100px" v-permission="'message_reply'">
        <el-button
          type="primary"
          @click="messageHide"
          style="border-radius: 100px"
          >消息回复</el-button
        >
      </div>
    </div>

    <div class="detail-body">
      <el-tabs value="t1">
        <el-tab-pane label="详情" name="t1">
          <el-descriptions
            style="margin-top: 20px"
            :colon="false"
            :column="1"
            :labelStyle="{
              display: 'inline',
              textAlign: 'right',
              color: '#4E5969',
              fontWeight: 500,
              fontSize: '14px',
              width: '60px',
            }"
            :contentStyle="{
              color: '#1D2129',
              borderBottom: '1px solid #E5E6EB',
              paddingBottom: '10px',
              marginBottom: '20px',
              display: 'block',
              flex: 1,
            }"
          >
            <el-descriptions-item label="当前状态">
              <div style="position: relative">
                <span
                  :style="{ color: stateMap[DetailData.Status || 0].color }"
                >
                  {{ stateMap[DetailData.Status || 0].text }}</span
                >
                <span
                  style="
                    position: absolute;
                    top: 0;
                    right: 5px;
                    cursor: pointer;
                    color: #165dff;
                  "
                  @click="resetStatus"
                  v-permission="'state_change'"
                >
                  修改
                </span>
              </div>
            </el-descriptions-item>
            <el-descriptions-item label="反馈内容">
              <div
                style="
                  padding: 5px 10px;
                  /* background: #f2f3f5; */
                  border-radius: 4px;
                "
              >
                {{ DetailData.Content || "-" }}
              </div></el-descriptions-item
            >
            <el-descriptions-item label="附图">
              <div style="min-height: 80px">
                <el-image
                  :key="index"
                  v-for="(item, index) in DetailData.Urls"
                  style="width: 80px; height: 80px; margin: 0 6px 6px 0"
                  :src="item"
                  :preview-src-list="[item]"
                >
                </el-image>
              </div>
            </el-descriptions-item>
            <el-descriptions-item label="联系方式">{{
              DetailData.Contact || "-"
            }}</el-descriptions-item>
            <el-descriptions-item label="备注">
              <el-input
                :disabled="!$jumpPerm('remark')"
                type="textarea"
                maxlength="1000"
                class="bz-ipt"
                placeholder="自由输入，限1000个字."
                v-model="Notes"
                :autosize="{ minRows: 3, maxRows: 6 }"
                @blur="NotesSave"
              >
              </el-input>
            </el-descriptions-item>
          </el-descriptions>
          <div style="text-align: center; padding: 10px">
            <el-button type="info" size="small" @click="backup">
              返回
            </el-button>
            <el-button type="primary" size="small" @click="delinfo">
              删除
            </el-button>
          </div>
        </el-tab-pane>
        <el-tab-pane label="绑定设备" name="t2">
          <el-table
            size="small"
            empty-text="暂无数据"
            :data="hisDevList"
            style="width: 100%"
          >
            <el-table-column prop="date" label="设备型号">
              <template slot-scope="scope">
                {{ scope.row.DeviceType || "-" }}
              </template>
            </el-table-column>
            <el-table-column prop="name" label="设备编号">
              <template slot-scope="scope">
                <div
                  v-if="scope.row.Gdid"
                  @click="toDevDetail(scope)"
                  style="color: #165dff; cursor: pointer"
                >
                  {{ scope.row.DeviceId || "-" }}
                </div>
                <!-- <router-link
                  v-if="scope.row.Gdid"
                  target="_blank"
                  :to="{
                    path: '/devDetail',
                    query: {
                      id: scope.row.Gdid,
                    },
                  }"
                >
                  {{ scope.row.DeviceId || "-" }}
                </router-link> -->
                <span v-else>
                  {{ scope.row.DeviceId || "-" }}
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="name" label="绑定时间">
              <template slot-scope="scope">
                {{ scope.row.BindTime || "-" }}
              </template>
            </el-table-column>
            <el-table-column prop="name" label="解绑时间">
              <template slot-scope="scope">
                {{ scope.row.UnbindTime || "-" }}
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="终端信息" name="t3">
          <el-table
            size="small"
            empty-text="暂无数据"
            :data="[
              {
                Agent: DetailData.Agent,
                AppOsVersion: DetailData.AppOsVersion,
                AppVersion: DetailData.AppVersion,
              },
            ]"
            style="width: 100%"
          >
            <el-table-column align="left" label="最近访问终端" prop="Agent">
            </el-table-column>
            <el-table-column align="left" label="终端版本" prop="AppOsVersion">
            </el-table-column>
            <el-table-column align="left" label="应用版本号" prop="AppVersion">
            </el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
    </div>

    <el-drawer
      title="消息回复"
      :size="650"
      :visible.sync="drawer"
      :direction="direction"
      :wrapperClosable="false"
      :before-close="handleClose"
    >
      <ReplyMessage
        :feedbackId="Number(id)"
        :UpdateStateData="DetailData"
        ref="ReplyMessage"
      />
    </el-drawer>
    <UpdateState
      :pwdDialogVisible.sync="pwdDialogVisible"
      :statusFormCurrentState.sync="statusFormCurrentState"
      @changFeedback="changFeedback"
      :UpdateStateData="DetailData"
      ref="UpdateState"
    />
  </div>
</template>

<script>
import ReplyMessage from "./ReplyMessage";
import UpdateState from "./UpdateState";
import {
  userFeedbackDetail,
  updateFeedbackStatus,
  feedbackdelete,
  requestUserDeviceList,
} from "@/api/userApi";
export default {
  components: {
    ReplyMessage,
    UpdateState,
  },
  props: {},
  data() {
    return {
      circleUrl: require("@/assets/images/useravatar@2x.png"),
      isEdit: false,
      Notes: "",
      drawer: false,
      direction: "rtl",
      pwdDialogVisible: false,
      id: 1,
      statusFormCurrentState: 0,
      DetailData: {},
      stateMap: {
        0: { text: "未处理", color: "#F53F3F" },
        1: { text: "进行中", color: "#00B42A" },
        2: { text: "已完成", color: "#165DFF" },
      },
      hisDevList: [],
    };
  },
  computed: {
    editFlag() {
      //修改用户反馈权限控制
      return (
        this.$store.state.userInfo.permissions.includes("updateFeedback") ||
        this.$store.getters.isAdmin
      );
    },
    removeFlag() {
      //删除用户反馈权限控制
      return (
        this.$store.state.userInfo.permissions.includes("deleteFeedback") ||
        this.$store.getters.isAdmin
      );
    },
  },
  watch: {},
  //方法集合
  methods: {
    toDevDetail(scope) {
      if (this.$jumpPerm("device_detail")) {
        this.$router.push({
          path: "/devDetail",
          query: {
            id: scope.row.Gdid,
          },
        });
      } else {
        this.$message({
          type: "error",
          message: "没有权限",
        });
      }
    },
    goUser() {
      if (this.$jumpPerm("user_detail")) {
        if (this.DetailData.UserId) {
          this.$router.push({
            path: "/userDetail",
            query: {
              id: this.DetailData.UserId,
              tabs: "first",
            },
          });
        }
      } else {
        this.$message({
          type: "error",
          message: "没有权限",
        });
      }
    },
    async initFeedbackDetail() {
      await this.userFeedbackDetailFn();
      this.Notes = this.DetailData.Remark;
    },
    async requestUserDeviceListfn() {
      try {
        var res = await requestUserDeviceList({
          userId: this.DetailData?.UserId,
        });
        if (res.data.data.result) {
          this.hisDevList = res.data.data.result;
        }
      } catch (err) {
        console.log(err);
      }
    },
    async NotesSave() {
      if (this.Notes === "") {
        // this.$message({
        //   message: "不能保存空备注",
        //   type: "error",
        // });
        return;
      }
      let res = await updateFeedbackStatus({
        id: this.id,
        remark: this.Notes,
      });
      if (res.data.data.result) {
        this.$message({
          message: "保存成功",
          type: "success",
        });
      } else {
        this.$message({
          message: "保存失败",
          type: "error",
        });
      }
      this.initFeedbackDetail();
      this.isEdit = false;
    },
    NotesCancel() {
      this.initFeedbackDetail();
      this.isEdit = false;
    },
    changFeedback() {
      this.userFeedbackDetailFn();
    },
    async userFeedbackDetailFn() {
      let res = await userFeedbackDetail({
        id: this.id,
      });
      this.statusFormCurrentState = res.data.data.result.Status;
      this.DetailData = res.data.data.result;
      // console.log(this.DetailData)
      this.requestUserDeviceListfn();
    },
    handleClose() {
      this.drawer = false;
      this.$refs.ReplyMessage.initMessage();
    },
    messageHide(row) {
      this.drawer = true;
      this.$nextTick(() => {
        this.$refs.ReplyMessage.addMessage();
      });
    },
    resetStatus() {
      this.statusFormCurrentState = this.DetailData.Status;

      this.pwdDialogVisible = true;
      this.$refs.UpdateState.initStatusForm();
    },
    pwdDialogVisibleChange(pwdDialogVisible) {
      this.pwdDialogVisible = pwdDialogVisible;
    },
    backup() {
      this.$router.go(-1);
    },
    delinfo() {
      //删除反馈信息
      this.$confirm("您确定要删除该反馈吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          var res = await feedbackdelete({
            id: this.id,
          });
          if (res.data.data && res.data.data.result) {
            this.$message({
              type: "success",
              message: "删除成功",
            });
            this.$router.replace({
              path: "/feedback",
            });
          } else {
            this.$message({
              type: "info",
              message: "删除失败",
            });
          }
        })
        .catch((err) => {
          console.log(err);
          this.$message({
            type: "info",
            message: "删除失败",
          });
        });
    },
  },
  created() {
    this.id = this.$route.query.id;
    this.userFeedbackDetailFn();
    this.initFeedbackDetail();
  },
  mounted() {},
  beforeCreate() {},
  beforeMount() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  activated() {},
};
</script>
<style lang="less">
.feedbackDetail {
  padding: 10px 25px;
  .detail-head {
    box-sizing: border-box;
    display: flex;
    width: 100%;
    padding: 20px;
    margin-bottom: 20px;
    background: #fff;
    .avator {
      width: 100px;
      height: 100px;
    }
  }
  .showUser {
    cursor: pointer;
    color: #409eff;
  }

  .detail-body {
    background: #fff;
    padding: 10px 20px;

    .el-tabs__nav-wrap::after {
      height: 0;
    }
  }

  .bz-ipt textarea {
    //background: #f2f3f5;
    border: 1px solid #f2f3f5;
  }
  .bz-ipt textarea:hover {
    border-color: #c0c4cc;
  }
  .bz-ipt textarea:focus {
    border-color: #409eff;
  }
}
</style>
